import "../App.css"
import React, { useState, useEffect } from "react";
import axios from "axios";

var id_ref = 0;

const Chatarea = () => {
  const [isLoading, setLoading] = useState(false)
  const [result, setResult] = useState([]);
  const [maxId, setMaxId] = useState(0);
  const [post, setPost] = useState({
    id: maxId,
    name:"user",
    message:"",
  });
  
const handleInput = (event) => {
  setPost({...post, [event.target.name]: event.target.value, id: maxId});
};

function handleSubmit(event) {
  event.preventDefault();
  setPost({ ...post, message: '' });
  setResult(prevResult => [...prevResult, post]);
  setMaxId(maxId + 1);
  setLoading(true);
  axios
    .post("https://islamicgpt.onrender.com/ask", post)
    .then((response) => {
      if (!Array.isArray(response.data)) {
        setResult(prevResult => [...prevResult, response.data]);
        setPost({ ...post, message: '' });
      } else {
        console.log("API response is not an array");
        setPost({ ...post, message: '' });
      }
    })
    .catch((error) => {
      console.log(error)
      setResult(prevResult => [...prevResult, error]);
      setPost({ ...post, message: '' });
    })
    .finally(() => {
      setLoading(false);
      id_ref += 1;
    })
}

const clearConversation = () => {
  setResult([]);
  setMaxId(0);
};

useEffect(() => {
  if (result.length > 0) {
    setMaxId(Math.max(...result.map(message => message.id)));
  }
}, [result]);

    return (
      <div className="d-flex justify-content-center align-items-center vh-100 flex-column min-vh-100">
      <div className="bg-light w-100 h-100 d-flex flex-column position-relative">
        <div className="container chat-container overflow-auto p-4 flex-grow-1">
          <div className="d-flex flex-column">
          {result.length > 0 ? (
            result.map((message) => (
        <p
        key={message.id}
        style={{borderRadius: "15px"}}
          className={`p-2 ${message.name === 'bot' ? 'bg-white' : 'bg-dark text-white'} mb-3 ${message.name === 'bot' ? 'align-self-start' : 'align-self-end'}`}
        >
          <p className="container poppins-medium my-1"><span className={`${message.name === 'bot' ? '' : ''}`}>{message.name === "bot" ? (result.length > 0 ? (message.message) : ("Sorry, something went wrong!")) : (message.message)}</span></p>
        </p>
      ))
    ) : (
        <p className="poppins-medium">Feel free to ask any questions related to Islam.</p>
    )}
    {isLoading && <p style={{borderRadius: "15px"}} className="p-2 bg-white mb-3 align-self-start"><div class="spinner-grow spinner-grow-sm text-dark my-1 m-left" role="status"> </div><span>    <div class="spinner-grow spinner-grow-sm text-dark my-1" role="status"></div></span><span>   <div class="spinner-grow spinner-grow-sm text-dark my-1 m-right" role="status"></div></span></p>}
      </div>
        </div>
        <form onSubmit={handleSubmit} className="container input-container p-4 d-flex position-sticky bottom-0 bg-light">
          <input
            type="text"
            name="message"
            value={post.message}
            className="form-control py-3 me-2 flex-grow-1 poppins-regular"
            placeholder="Ask your questions..."
            onChange={handleInput}
            required
            disabled={isLoading}
          />
          <button type="submit" className="btn btn-dark p-3" disabled={isLoading}><i className="fa-solid fa-paper-plane"></i></button>
          {result.length > 0 ? (<button type="button" disabled={isLoading} className="btn btn-danger p-3 mx-1" onClick={clearConversation}><i className="fa-solid fa-trash-can"></i></button>) : (null)}
        </form>
        <center><p className="poppins-regular">For more projects like this <a className="text-dark" href="https://ko-fi.com/yahyazoom1727">support now!</a></p></center>
      </div>
    </div>
    );
};

export default Chatarea;